import React from 'react';
import { FadeInUp } from './FadeInUp';
import { XCircle, CheckCircle2 } from 'lucide-react';
export function TwoPathsClose() {
  return <section className="py-20 px-6 bg-white" data-id="element-333">
      <div className="max-w-5xl mx-auto" data-id="element-334">
        <FadeInUp data-id="element-335">
          <h2 className="font-serif text-3xl md:text-4xl font-bold mb-16 text-center text-deep-green" data-id="element-336">
            Tienes dos caminos
          </h2>
        </FadeInUp>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-337">
          {/* Left Path */}
          <FadeInUp delay={0.1} data-id="element-338">
            <div className="bg-gray-50 border border-gray-200 p-8 md:p-10 rounded-3xl h-full opacity-80 hover:opacity-100 transition-opacity" data-id="element-339">
              <div className="w-14 h-14 bg-red-100 rounded-2xl flex items-center justify-center mb-8 text-red-500" data-id="element-340">
                <XCircle className="w-7 h-7" data-id="element-341" />
              </div>
              <h3 className="font-serif text-2xl font-bold text-charcoal mb-6" data-id="element-342">
                Seguir como estás
              </h3>
              <ul className="space-y-4" data-id="element-343">
                <li className="flex items-start gap-3 text-charcoal/70" data-id="element-344">
                  <XCircle className="w-5 h-5 text-red-400 shrink-0 mt-0.5" data-id="element-345" />
                  <span data-id="element-346">Seguir hinchada cada noche</span>
                </li>
                <li className="flex items-start gap-3 text-charcoal/70" data-id="element-347">
                  <XCircle className="w-5 h-5 text-red-400 shrink-0 mt-0.5" data-id="element-348" />
                  <span data-id="element-349">Probar otra dieta que no funciona</span>
                </li>
                <li className="flex items-start gap-3 text-charcoal/70" data-id="element-350">
                  <XCircle className="w-5 h-5 text-red-400 shrink-0 mt-0.5" data-id="element-351" />
                  <span data-id="element-352">Gastar $20.000 en cosas que no dan resultado</span>
                </li>
                <li className="flex items-start gap-3 text-charcoal/70" data-id="element-353">
                  <XCircle className="w-5 h-5 text-red-400 shrink-0 mt-0.5" data-id="element-354" />
                  <span data-id="element-355">
                    Gastar en suplementos y batidos caros que no dan resultado
                  </span>
                </li>
                <li className="flex items-start gap-3 text-charcoal/70" data-id="element-356">
                  <XCircle className="w-5 h-5 text-red-400 shrink-0 mt-0.5" data-id="element-357" />
                  <span data-id="element-358">Sentirte frustrada con tu cuerpo</span>
                </li>
              </ul>
            </div>
          </FadeInUp>

          {/* Right Path */}
          <FadeInUp delay={0.2} data-id="element-359">
            <div className="bg-cream border-2 border-gold/30 p-8 md:p-10 rounded-3xl h-full shadow-xl relative overflow-hidden group" data-id="element-360">
              <div className="absolute inset-0 bg-gradient-to-br from-gold/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-361"></div>
              <div className="relative z-10" data-id="element-362">
                <div className="w-14 h-14 bg-sage/20 rounded-2xl flex items-center justify-center mb-8 text-sage shadow-sm" data-id="element-363">
                  <CheckCircle2 className="w-7 h-7" data-id="element-364" />
                </div>
                <h3 className="font-serif text-2xl font-bold text-deep-green mb-6" data-id="element-365">
                  Empezar hoy por $4.990
                </h3>
                <ul className="space-y-4" data-id="element-366">
                  <li className="flex items-start gap-3 text-charcoal/80 font-medium" data-id="element-367">
                    <CheckCircle2 className="w-5 h-5 text-sage shrink-0 mt-0.5" data-id="element-368" />
                    <span data-id="element-369">Un plan claro de 7 días</span>
                  </li>
                  <li className="flex items-start gap-3 text-charcoal/80 font-medium" data-id="element-370">
                    <CheckCircle2 className="w-5 h-5 text-sage shrink-0 mt-0.5" data-id="element-371" />
                    <span data-id="element-372">Ingredientes que ya tienes en casa</span>
                  </li>
                  <li className="flex items-start gap-3 text-charcoal/80 font-medium" data-id="element-373">
                    <CheckCircle2 className="w-5 h-5 text-sage shrink-0 mt-0.5" data-id="element-374" />
                    <span data-id="element-375">Resultados desde los primeros días</span>
                  </li>
                  <li className="flex items-start gap-3 text-charcoal/80 font-medium" data-id="element-376">
                    <CheckCircle2 className="w-5 h-5 text-sage shrink-0 mt-0.5" data-id="element-377" />
                    <span data-id="element-378">Garantía de 7 días sin riesgo</span>
                  </li>
                </ul>
              </div>
            </div>
          </FadeInUp>
        </div>
      </div>
    </section>;
}